import Event from '../../core/Event';

export default class UserEstimationRequested extends Event {
    public static type = 'UserEstimationRequested';

    constructor(public readonly estimationId: string, public readonly customerId: string) {
        super(UserEstimationRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/UserEstimationRequested.ts